import React, { useEffect } from "react";

const useScrollTop = () => {
  useEffect(() => {
    if (typeof window !== undefined) {
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    }
  }, []);
};

export default useScrollTop;
